function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Notifications");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M8.46153846,20 C9.55656109,20 10.4524887,19.1 10.4524887,18 L6.47058824,18 C6.47058824,19.1 7.36651584,20 8.46153846,20 Z M14.9321267,14 L14.9321267,8.5 C14.9321267,5.4 12.841629,2.9 9.95475113,2.2 L9.95475113,1.5 C9.95475113,0.7 9.25791855,0 8.46153846,0 C7.66515837,0 6.96832579,0.7 6.96832579,1.5 L6.96832579,2.2 C4.08144796,2.9 1.99095023,5.4 1.99095023,8.5 L1.99095023,14 L-2.13162821e-14,16 L-2.13162821e-14,17 L16.9230769,17 L16.9230769,16 L14.9321267,14 Z M13.8461538,15.6538462 L3.07692308,15.6538462 L3.07692308,8.38111888 C3.07692308,5.58391608 5.47008547,3.34615385 8.46153846,3.34615385 C11.4529915,3.34615385 13.8461538,5.58391608 13.8461538,8.38111888 L13.8461538,15.6538462 Z",
  id: "noti",
  fill: "#215EFF",
  fillRule: "nonzero"
}));

var SvgNoti = function SvgNoti(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "17px",
    height: "20px",
    viewBox: "0 0 17 20",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNoti, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noti.33ad88ad.svg";
export { ForwardRef as ReactComponent };